'use client';

import MobileDetect from 'mobile-detect';
import type { FC, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import { useDataPopup } from '../hooks/useDataPopup';
import { useTruth } from '../hooks/useTruth';
import { messages } from '../messages';

interface ConditionDeviceTypeProps extends PropsWithChildren {
  phone?: string;
  tablet?: string;
  desktop?: string;
}

export const ConditionDeviceType: FC<ConditionDeviceTypeProps> = ({
  phone,
  tablet,
  desktop,
  children,
}) => {
  const { dataBlocks } = useTruth();
  const { DataPopup } = useDataPopup();

  const { browserName, browserVersion, os } = dataBlocks;

  const [handle, setHandle] = useState<React.ReactNode>(children);

  useEffect(() => {
    if (typeof window === 'undefined' || !window) return;

    const md = new MobileDetect(window.navigator.userAgent);

    if (md.tablet()) {
      setHandle(tablet);
    } else if (md.mobile() || md.phone()) {
      setHandle(phone);
    } else {
      setHandle(desktop);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- reads the user agent once on mount; branch props are static JSX
  }, []);

  return (
    <DataPopup
      handle={handle}
      subheading={messages['condition.deviceType.description']}
      condition={{
        title: messages['condition.deviceType'],
        options: [
          {
            title: messages['condition.deviceType.phone'],
            value: phone,
          },
          {
            title: messages['condition.deviceType.tablet'],
            value: tablet,
          },
          {
            title: messages['condition.deviceType.desktopOther'],
            value: desktop,
          },
        ],
      }}
      dataBlocks={{ browserName, browserVersion, os }}
    />
  );
};
